var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreateNewItemInCatalog',{attrs:{"app_mode":"","btn_text":_vm.item ? '' : _vm.$t('Catalog.CreatePosition'),"create":_vm.item ? _vm.editItem : _vm.createNewCart,"data-qa":"create-new-item-in-catalog","dialog_name":_vm.item ? _vm.$t('Common.Edit') : '',"get-measur":"setMeasurements","item":_vm.item},on:{"searching":_vm.searching}})
}
var staticRenderFns = []

export { render, staticRenderFns }